<template>
  <div class="volunteer-content list-search-content">
    <!-- 左侧 -->
    <div
      class="left-content"
      v-loading="loading"
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
    >
      <el-scrollbar style="height: 100%" ref="myScrollbar">
        <el-row v-if="showAdd" :gutter="20">
          <div class="month-title">
            <span>{{month}}</span>
            <span>
              0
              <span>篇</span>
            </span>
          </div>
          <el-col :span="6">
            <div class="add-box" @click="gopage('/peopleOnline/volunteer/add')"></div>
          </el-col>
        </el-row>
        <el-row v-for="(item,index) in activityList" :key="index" :gutter="20">
          <div class="month-title">
            <span>{{item.months}}</span>
            <span>
              {{item.everymonthdata.length}}
              <span>篇</span>
            </span>
          </div>
          <el-col :span="6" v-if="item.months===month">
            <div class="add-box" @click="gopage('/peopleOnline/volunteer/add')"></div>
          </el-col>
          <el-col :span="6" v-for="(list,index) in  item.everymonthdata" :key="index">
            <el-card class="box-card">
              <div>
                <div class="activity-img" @click="toEdit(list.id)">
                  <img :src="list.activityPicture" alt />
                  <div>招募率：{{list.recruitedNum}}/{{list.activityRecruitsNum}}</div>
                </div>
                <div class="activity-title">{{list.activityTheme}}</div>
                <div class="apply-detail">
                  <span @click="toDetail(list.id)">查看招募</span>
                  <el-button
                    type="primary"
                    size="small"
                    class="mini-btn"
                    :disabled="list.activityStatus !== '0'"
                    @click="publish(list.id)"
                  >
                    <span v-if="list.activityStatus === '0'">发布</span>
                    <span v-if="list.activityStatus === '1'">已发布</span>
                    <span v-if="list.activityStatus === '2'">招募中</span>
                    <span v-if="list.activityStatus === '3'">招募完成</span>
                    <span v-if="list.activityStatus === '4'">招募结束</span>
                    <span v-if="list.activityStatus === '5'">进行中</span>
                    <span v-if="list.activityStatus === '6'">已结束</span>
                  </el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-scrollbar>
    </div>

    <!-- 右侧 -->
    <aside class="aside-content">
      <el-form :model="reqData" ref="ruleForm" class="search-form">
        <div class="form-header">
          <span>筛选</span>
          <el-button @click="resetForm('ruleForm')" type="primary" size="mini" class="mini-btn">重置</el-button>
        </div>
        <el-form-item label="文章标题" prop="activityTheme">
          <el-input
            v-model="reqData.activityTheme"
            placeholder="请输入..."
            @blur="getData"
            @keyup.enter.native="getData"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker
            @change="getData"
            @blur="getData"
            v-model="reqData.time"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分类" prop="activityKindId" class="typeItem">
          <el-input
            v-model="activityKindName"
            placeholder="添加分类"
            size="small"
            @blur="addType"
            @keyup.enter.native="addType"
          ></el-input>
          <el-checkbox-group v-model="reqData.activityKindId" @change="getData">
            <el-checkbox
              :label="item.id"
              class="typeLists"
              v-for="(item,index) in typeList"
              :key="index"
            >
              <span>{{item.activityKindName}}</span>
              <i class="el-icon-close del-icon" @click="delType(item.id)"></i>
              <span class="typeNum">{{item.count}}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </aside>
  </div>
</template>
<script>
import api from "@/api/peopleOnline/volunteer.js";
import { getNowFormatDate } from "@/utils/auth.js";
export default {
  data() {
    return {
      loading: false,
      showAdd: true,
      activityKindName: "",
      typeList: [],
      activityList: [],
      reqData: {
        time: [],
        activityKindId: [],
        begincreatetimeStr: "",
        endcreatetimeStr: "",
        activityTheme: "",
        page: 1,
        row: 100
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    month() {
      return getNowFormatDate();
    }
  },
  mounted() {
    this.getData();
    this.getTypeList();
  },
  methods: {
    // 获取活动列表
    async getData() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.reqData));
      data.communityId = this.userInfo.communityId;
      data.begincreatetimeStr =
        data.time && data.time.length > 0 ? data.time[0] : "";
      data.endcreatetimeStr =
        data.time && data.time.length > 0 ? data.time[1] : "";
        console.log(this.reqData.activityKindId)
      data.activityKindId = data.activityKindId.join(",");
      delete data.time;
      let res = await this.$http.get(`${api.activityList}`,{params:data});
      if (res && res.isSucceed) {
        this.loading = false;
        this.showAdd = true;
        this.activityList = res.rows;
        for (let item of this.activityList) {
          if (item.months === this.month) {
            this.showAdd = false;
            return;
          }
        }
      }
    },
    // 获取分类列表
    async getTypeList() {
      let data = {
        page: 1,
        rows: 100,
        communityId: this.userInfo.communityId
      };
      let res = await this.$http.get(`${api.typeList}`, { params: data });
      if (res && res.isSucceed) {
        this.typeList = res.rows;
      }
    },
    // 添加分类
    async addType() {
      if (this.activityKindName==='') {
        return;
      }
      let res = await this.$http.post(
        api.addType,
        this.$qs.stringify({
          activityKindName: this.activityKindName,
          communityId: this.userInfo.communityId
        })
      );
      if (res && res.isSucceed) {
        this.activityKindName = "";
        this.getTypeList();
      }
    },
    // 删除分类
    async delType(id) {
      event.preventDefault();
      let res = await this.$http.get(`${api.delType}?id=${id}`);
      if (res && res.isSucceed) {
        this.getTypeList();
        this.getData();
      }
    },
    // 跳转页面
    gopage(path) {
      this.$router.push(path);
    },
    async publish(id) {
      let res = await this.$http.post(
        api.publishActivity,
        this.$qs.stringify({ id: id })
      );
      if (res && res.isSucceed) {
        this.getData();
      }
    },
    toEdit(id) {
      this.$router.push({
        name: "peoVolunteerAdd",
        query: {
          id: id
        }
      });
    },
    toDetail(id) {
      this.$router.push({
        name: "peoVolunteerDetail",
        query: {
          id
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getData();
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./index.less");
</style>
<style lang='less'>
@import url("./ele-index.less");
</style>